<div class="weekly-duration">
  <h2 class="weekly-duration__title">{{ field.placeholder }}&nbsp;:</h2>
  <ul [formGroup]="durationForm" class="weekly-duration__selects">
    <li>
      <mat-form-field class="without-legacy-arrow" floatLabel="never" appearance="legacy">
        <mat-label>de<span class="weekly-duration__select-label">00</span>h</mat-label>
        <mat-select
          role="listbox"
          [aria-label]="
            field.ariaLabel +
            ', liste déroulante pour sélectionner le nombre d\'heure minimum pour la durée hébdomadaire'
          "
          #selectFrom="matSelect"
          formControlName="durationSelectFrom"
          panelClass="dropdown-panel"
        >
          <mat-select-trigger> de {{ durationSelectFrom?.value | number: '2.0' }} h</mat-select-trigger>
          <mat-option
            role="option"
            *ngFor="let option of fromOptions$ | async; trackBy: trackByOption"
            [value]="option"
            >{{ option }}</mat-option
          >
        </mat-select>
        <mat-icon
          *ngIf="!durationSelectFrom?.value"
          matSuffix
          class="weekly-duration__icon__arrow"
          [class.weekly-duration__icon__arrow--open]="selectFrom.panelOpen"
          svgIcon="arrow_next"
          role="presentation"
        ></mat-icon>
        <button
          type="button"
          matSuffix
          class="delete-btn btn-clean"
          *ngIf="!!durationSelectFrom?.value"
          [attr.aria-label]="
            'Suppresion du filtre de ' +
            field.ariaLabel +
            ', liste déroulante pour sélectionner le nombre d\'heure minimum pour la durée hébdomadaire'
          "
          (click)="clearValueSelectFrom($event)"
        >
          <mat-icon svgIcon="cross" class="weekly-duration__icon__delete" role="presentation"></mat-icon>
        </button>
      </mat-form-field>
    </li>
    <li>
      <mat-form-field class="without-legacy-arrow" appearance="legacy" floatLabel="never">
        <mat-label>à<span class="weekly-duration__select-label">00</span>h</mat-label>
        <mat-select
          [aria-label]="
            field.ariaLabel +
            ', liste déroulante pour sélectionner le nombre d\'heure maximum pour la durée hébdomadaire'
          "
          #selectTo="matSelect"
          formControlName="durationSelectTo"
          role="listbox"
          panelClass="dropdown-panel"
        >
          <mat-select-trigger> à {{ durationSelectTo?.value | number: '2.0' }} h</mat-select-trigger>
          <mat-option
            role="option"
            *ngFor="let option of toOptions$ | async; trackBy: trackByOption"
            [value]="option"
            >{{ option }}</mat-option
          >
        </mat-select>
        <mat-icon
          *ngIf="!durationSelectTo?.value"
          matSuffix
          class="weekly-duration__icon__arrow"
          [class.weekly-duration__icon__arrow--open]="selectTo.panelOpen"
          svgIcon="arrow_next"
          role="presentation"
        ></mat-icon>
        <button
          type="button"
          matSuffix
          class="delete-btn btn-clean"
          *ngIf="!!durationSelectTo?.value"
          [attr.aria-label]="
            'Suppresion du filtre de ' +
            field.ariaLabel +
            ', liste déroulante pour sélectionner le nombre d\'heure maximum pour la durée hébdomadaire'
          "
          (click)="clearValueSelectTo($event)"
        >
          <mat-icon svgIcon="cross" class="weekly-duration__icon__delete" role="presentation"></mat-icon>
        </button>
      </mat-form-field>
    </li>
  </ul>
</div>
